import { VDataTable } from 'vuetify/lib/components/VDataTable';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VDataTable,{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.results,"items-per-page":5,"item-class":_vm.row_classes}})}
var staticRenderFns = []

export { render, staticRenderFns }